/* eslint-disable import/no-cycle */
import { ManagementBreadcrumbTitlesKey } from './managementRoutes';
import { stakeholderManagementbreadcrumbTitlesKey } from './stakeholderManagementRoutes';
import { stakeholderOperationbreadcrumbTitlesKey } from './stakeholderOperationRoutes';

export { managementRoutes } from './managementRoutes';
export { stakeholderManagementRoutes } from './stakeholderManagementRoutes';
export { stakeholderOperationRoutes } from './stakeholderOperationRoutes';
export const breadcrumbTitlesKey = {
  ...ManagementBreadcrumbTitlesKey,
  ...stakeholderManagementbreadcrumbTitlesKey,
  ...stakeholderOperationbreadcrumbTitlesKey
};
